// import { PageTab } from "../../../components";
// import PlacementInvoices from "./Addinvoives/PlacementInvoives";
// import PermenentInvoices from "./Addinvoives/PermenentInvoices";
// import { useState } from "react";
// import ViewAwaitingInvoices from "./Addinvoives/ViewAwaitingInvoices";

// const AddInvoices = () => {
//   const [viewAwaitingApprovals, setViewAwaitingApprovals] = useState(false);
//   const addInvoiceTabs = [
//     {
//       title: "Placement Invoices",
//       page: <PlacementInvoices setViewApprovals={setViewAwaitingApprovals} />,
//       type: "main",
//     },
//     {
//       title: "Permanent Invoices",
//       page: <PermenentInvoices setViewApprovals={setViewAwaitingApprovals} />,
//       type: "main",
//     },
//   ];

//   // const handleBackToInvoices = () => {
//   //   setViewAwaitingApprovals(false);
//   // };

//   return (
//     <div>
//       {viewAwaitingApprovals ? (
//         // <ViewAwaitingInvoices onBack={handleBackToInvoices} />
//         <ViewAwaitingInvoices />
//       ) : (
//         <NewTab
//           tabs={addInvoiceTabs}
//           color="black"
//           variant="text"
//           activeVariant="text"
//         />
//       )}
//     </div>
//   );
// };

// export default AddInvoices;

import { NewTab, PageTab } from "../../../components";
import PlacementInvoices from "./Addinvoives/PlacementInvoives";
import PermenentInvoices from "./Addinvoives/PermenentInvoices";
import { useState } from "react";
import ViewAwaitingInvoices from "./Addinvoives/ViewAwaitingInvoices";
import CreditMemo from "./Addinvoives/CreditMemo";

const AddInvoices = () => {
  const [viewAwaitingApprovals, setViewAwaitingApprovals] = useState(false);

  const handleBack = () => {
    setViewAwaitingApprovals(false);
  };

  const addInvoiceTabs = [
    {
      title: "Placement Invoices",
      page: <PlacementInvoices setViewApprovals={setViewAwaitingApprovals} />,
      type: "main",
    },
    {
      title: "Permanent Invoices",
      page: <PermenentInvoices setViewApprovals={setViewAwaitingApprovals} />,
      type: "main",
    },
    // {
    //   title: "Credit Memo",
    //   page: <CreditMemo onBack={handleBack} />,
    //   type: "sub",
    // },
  ];

  return (
    <div className="flex-1 flex h-full">
      {viewAwaitingApprovals ? (
        <ViewAwaitingInvoices onBack={handleBack} />
      ) : (
        <NewTab
          tabs={addInvoiceTabs}
          color="black"
          variant="text"
          activeVariant="text"
          hideMainOnSubActive={true} // This prevents side-by-side rendering
          mode="url"
          tabId="add-invoices"
        />
      )}
    </div>
  );
};

export default AddInvoices;
